import CloseIcon from "@mui/icons-material/Close";
import { Box, useTheme } from "@mui/material";
import React, { useContext, useState } from "react";

import { WsTemplate } from "@storyboard/web-client";
import { useReactiveSelectQuery } from "@/models/hooks/useReactiveSelectQuery.ts";
import { cachedTemplatesSelect } from "@/models/repositories";
import { WorkspaceContext } from "@/models/StateProviders/workspaceProvider.tsx";

export default function ListTemplates({
  setTemplateText,
  hideTemplates,
}: {
  setTemplateText: (template: string) => void;
  hideTemplates: () => void;
}) {
  const theme = useTheme();
  const [activeTemplate, setActiveTemplate] = useState<string>("");
  const setTemplate = (template: WsTemplate) => {
    setActiveTemplate(() => template.id);
    setTemplateText(template.template);
  };
  const { currentWorkspaceId } = useContext(WorkspaceContext);
  const templates =
    useReactiveSelectQuery(cachedTemplatesSelect, [{ workspaceId: currentWorkspaceId }], "FleetMessaging:templates") ??
    [];
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        border: `solid 2px ${theme.palette.secondary.main}`,
        borderRadius: "0.5rem",
        position: "absolute",
        zIndex: 10,
        background: theme.palette.secondary.dark,
      }}
    >
      <Box
        sx={{
          height: "30px",
          px: 2,
          fontWeight: "bold",
          fontSize: "1.25rem",
          background: theme.palette.secondary.main,
          borderBottom: `solid 1px ${theme.palette.secondary.light}`,
          borderTopLeftRadius: "0.25rem",
          borderTopRightRadius: "0.25rem",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <span>{templates?.length}</span> Templates
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            onClick={() => hideTemplates()}
            component="button"
            className="basic-button"
            sx={{
              display: "flex",
              alignItems: "center",
              color: "#ccc",
              "&:hover": { background: "#555", color: "#fff" },
            }}
          >
            <CloseIcon role="img" sx={{ fontSize: "20px" }} />
          </Box>
        </Box>
      </Box>
      <Box sx={{ height: "calc(100% - 30px)", width: "100%", overflow: "auto", p: 2 }}>
        {templates?.map((template) => (
          <Box
            key={template.id}
            onClick={() => setTemplate(template)}
            component="button"
            className={`basic-button ${activeTemplate === template.id ? "no-hover" : ""}`}
            sx={{
              border: `solid 1px ${activeTemplate === template.id ? theme.palette.info.main : theme.palette.secondary.light}`,
              background: `${activeTemplate === template.id ? theme.palette.secondary.dark : "transparent"}`,
              display: "block",
              width: "100%",
              textAlign: "left",
              mb: 1,
              p: 1,
              borderRadius: 1,
            }}
          >
            {template.name}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
